import * as types from "../types/heldOrders"

export const addHeldOrder = (order) => ({
  type: types.ADD_HELD_ORDER,
  order
})

export const deleteAllHeldOrders = () => ({
  type: types.DELETE_ALL_HELD_ORDERS
})

export const deleteHeldOrder = (heldOrderId) => ({
  type: types.DELETE_HELD_ORDER,
  heldOrderId
})